import ReferenceErrorPage from '../../theme/screens/error-page/sno.scss';

export default {
    ReferenceErrorPage,
};
